export default __webpack_public_path__ + "static/media/avatar-s2.44355384.png";